"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _components = require("./components");
var _utils = require("./lib/utils");
var _states = require("./lib/constants/states");
const propTypes = {
  availability: _propTypes.array,
  messages: (0, _propTypes.shape)({
    availabilityErrorMsg: _propTypes.node.isRequired,
    availabilityNoMoreRetriesMsg: _propTypes.node.isRequired,
    availabilityTryAgainBtnText: _propTypes.node.isRequired,
    moreAvailabilitiesLinkText: _propTypes.node.isRequired,
    showAvailabilitiesBtnText: _propTypes.node.isRequired,
    noAvailabilityMessage: _propTypes.node.isRequired
  }).isRequired,
  onClickShowAvailability: _propTypes.func.isRequired,
  handleRetry: _propTypes.func.isRequired,
  providerId: _propTypes.number.isRequired,
  maxAvailabilitiesToDisplay: _propTypes.number.isRequired,
  currentState: (0, _propTypes.shape)({
    context: (0, _propTypes.shape)({
      apptInfo: (0, _propTypes.shape)({
        relationship: _propTypes.string.isRequired,
        purpose: _propTypes.string.isRequired
      }),
      provider: (0, _propTypes.shape)({
        book_online_url: _propTypes.string.isRequired
      })
    }),
    matches: _propTypes.func.isRequired
  }),
  availabilityLinkTarget: _propTypes.string,
  onTimeSlotsClick: _propTypes.func,
  isAvailabilityReadOnly: _propTypes.bool,
  onAvailabilityTilesLoaded: _propTypes.func,
  onViewMoreClick: _propTypes.func
};
function AvailabilityTiles(_ref) {
  let {
    availability,
    onClickShowAvailability,
    handleRetry,
    providerId,
    maxAvailabilitiesToDisplay,
    messages,
    currentState,
    availabilityLinkTarget,
    onTimeSlotsClick,
    isAvailabilityReadOnly,
    onAvailabilityTilesLoaded,
    onViewMoreClick
  } = _ref;
  const {
    availabilityErrorMsg,
    availabilityNoMoreRetriesMsg,
    availabilityTryAgainBtnText,
    moreAvailabilitiesLinkText,
    showAvailabilitiesBtnText,
    noAvailabilityMessage
  } = messages;
  if (currentState.matches(_states.idle)) {
    return /*#__PURE__*/_react.default.createElement(_components.HiddenAvailabilityTiles, {
      maxAvailabilitiesToDisplay: maxAvailabilitiesToDisplay,
      onClickShowAvailabilities: onClickShowAvailability,
      showAvailabilitiesBtnText: showAvailabilitiesBtnText
    });
  }
  if (currentState.matches(_states.pending) || currentState.matches(_states.debouncing)) {
    return /*#__PURE__*/_react.default.createElement(_components.LoadingAvailabilityTiles, {
      maxAvailabilitiesToDisplay: maxAvailabilitiesToDisplay
    });
  }
  if (currentState.matches(_states.retry) || currentState.matches(_states.done)) {
    return /*#__PURE__*/_react.default.createElement(_components.ErrorAvailabilityTiles, {
      errorMsg: availabilityErrorMsg,
      noMoreRetriesMsg: availabilityNoMoreRetriesMsg,
      tryAgainBtnText: availabilityTryAgainBtnText,
      hasMoreRetries: !currentState.matches(_states.done),
      onTryAgain: handleRetry
    });
  }
  if (currentState.matches(_states.success)) {
    const bookOnlineUrl = currentState.context.provider.book_online_url;
    const availabilities = (0, _utils.oldFormatAvailabilityForTiles)(availability, bookOnlineUrl);
    const viewMoreBookOnlineUrl = !isAvailabilityReadOnly && currentState.context.apptInfo ? (0, _utils.createBookingDeepLink)({
      ...currentState.context.apptInfo,
      providerId
    }) : '';
    return /*#__PURE__*/_react.default.createElement(_components.VisibleAvailabilityTiles, {
      availabilities: availabilities,
      maxAvailabilitiesToDisplay: maxAvailabilitiesToDisplay,
      displayLinkToViewMoreAvailabilities: true,
      moreAvailabilitiesLinkText: moreAvailabilitiesLinkText,
      isAvailabilityReadOnly: isAvailabilityReadOnly,
      viewMoreBookOnlineUrl: viewMoreBookOnlineUrl,
      noAvailabilityMessage: noAvailabilityMessage,
      linkTarget: availabilityLinkTarget,
      onTimeSlotsClick: onTimeSlotsClick,
      onAvailabilityTilesLoaded: onAvailabilityTilesLoaded,
      providerId: providerId,
      onViewMoreClick: onViewMoreClick
    });
  }
}
AvailabilityTiles.propTypes = propTypes;
var _default = exports.default = AvailabilityTiles;
AvailabilityTiles.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AvailabilityTiles",
  "props": {
    "availability": {
      "description": "",
      "type": {
        "name": "array"
      },
      "required": false
    },
    "messages": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "availabilityErrorMsg": {
            "name": "node",
            "required": true
          },
          "availabilityNoMoreRetriesMsg": {
            "name": "node",
            "required": true
          },
          "availabilityTryAgainBtnText": {
            "name": "node",
            "required": true
          },
          "moreAvailabilitiesLinkText": {
            "name": "node",
            "required": true
          },
          "showAvailabilitiesBtnText": {
            "name": "node",
            "required": true
          },
          "noAvailabilityMessage": {
            "name": "node",
            "required": true
          }
        }
      },
      "required": true
    },
    "onClickShowAvailability": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "handleRetry": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "providerId": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "maxAvailabilitiesToDisplay": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "currentState": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "context": {
            "name": "shape",
            "value": {
              "apptInfo": {
                "name": "shape",
                "value": {
                  "relationship": {
                    "name": "string",
                    "required": true
                  },
                  "purpose": {
                    "name": "string",
                    "required": true
                  }
                },
                "required": false
              },
              "provider": {
                "name": "shape",
                "value": {
                  "book_online_url": {
                    "name": "string",
                    "required": true
                  }
                },
                "required": false
              }
            },
            "required": false
          },
          "matches": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": false
    },
    "availabilityLinkTarget": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onTimeSlotsClick": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "isAvailabilityReadOnly": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onAvailabilityTilesLoaded": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onViewMoreClick": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};